import { useQuery } from '@tanstack/react-query'
import { request } from '@/lib/api'

/**
 * Ставки налога, действующие на дату (`GET /api/v1/tax-rates`, V57).
 *
 * Открыто каждому, кто вошёл: форма товара и строки документа должны предложить выбор, а
 * справочник правит только администратор (`system.settings`). Товар хранит **код** ставки
 * (`vat_standard`), а не процент: процент основной ставки зависит от даты — 20 % в 2025
 * году, 22 % с 2026-го, — и поле товара с числом устаревало бы первого января.
 */
export interface EffectiveTaxRate {
  id: string
  code: string
  name: string
  kind: string
  percent: number
  estimated: boolean
}

const fetchEffectiveTaxRates = (on?: string, signal?: AbortSignal) =>
  request<{ on: string; rates: EffectiveTaxRate[] }>(on ? `/tax-rates?on=${encodeURIComponent(on)}` : '/tax-rates', { signal })
    .then((response) => response.rates)

/** Действующие сегодня ставки — общий кеш для формы и карточки товара. */
export function useEffectiveTaxRates() {
  return useQuery({
    queryKey: ['tax-rates-effective'],
    queryFn: ({ signal }) => fetchEffectiveTaxRates(undefined, signal),
    staleTime: 5 * 60_000,
  })
}
